'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fitnessTrendsMember = undefined;

var _sagaTools = require('@classpass/saga-tools');

var _FitnessTrends = require('derivers/FitnessTrends');

var KEY = 'SAGA.API.FITNESS_TRENDS';

var fitnessTrendsMember = exports.fitnessTrendsMember = (0, _sagaTools.makeEntityScaffold)(KEY + '.GET_MEMBER', function (client, year, memberHash) {
  return client.statics.fitnessTrendsMember(year, memberHash).then(function (data) {
    return _FitnessTrends.FitnessTrends.member(data);
  });
});